@if (_entityType === entityTypes.OUTLET) {
    @if (fullEntity && !fullEntity.id) {
        <agpr-message
            [severity]="messageSeverityEnum.noContent"
            [useWhiteBg]="true"
        >
            <span>
                {{ 'Discover.entityProfile.noSystemOutlet' | localize }}
            </span>
        </agpr-message>
    } @else if (!fullEntity) {
        <agpr-message
            [severity]="messageSeverityEnum.noContent"
            [useWhiteBg]="true"
            [style.display]="hiddenNoContentMessage ? 'none' : 'block'"
        >
            <span>
                {{ noOutletMessage | localize }}
            </span>
        </agpr-message>
    }
} @else if (_entityType === entityTypes.CONTACT && !fullEntity) {
    <agpr-message
        [severity]="messageSeverityEnum.noContent"
        [useWhiteBg]="true"
        [style.display]="hiddenNoContentMessage ? 'none' : 'block'"
    >
        <span>
            {{ noContactMessage | localize }}
        </span>
    </agpr-message>
}


@if (fullEntity && fullEntity.id) {
    <div
        class="agpr-entityProfile"
        [@showMoreContent]="annimationState"
    >
        <agpr-entity-business-card
            [id]="id + '_contactDetailsBusinessCard'"
            [isRHP]="true"
            [entity]="fullEntity"
            [contactPrivateData]="contactPrivateData"
            [outletPrivateData]="outletPrivateData"
            [canOpenFullProfile]="(targetingAccessLevel === targetingAccessLevels.ADVANCED) && !isGeoRestricted && !disableFullProfile"
            [fullHeightProfileTakeover]="fullHeightProfileTakeover"
            (selectedEmploymentChanged)="employmentSelectedFromDropdown($event)"
        ></agpr-entity-business-card>

        @if (fullEntity?.bio) {
            <agpr-panel
                [id]="id + '_contactDetails.entityProfile.bio'"
                header="Discover.entityProfile.bio"
                [marginTop]="15"
                [headingLevel]="5"
            >
                <div class="agpr-profileSection-content">{{ fullEntity.bio }}</div>
            </agpr-panel>
        }

        @if (showMore || isRefMediaAccount) {
            @if (subjects?.length > 0) {
                <agpr-panel
                    [id]="id + '_contactDetails.entityProfile.subjects'"
                    header="Discover.entityProfile.subjects"
                    [headingLevel]="5"
                    [marginTop]="15"
                >
                    @for (topSubject of subjects; track topSubject.id; let lastSub = $last) {
                        <dl
                            class="agpr-profileSection-content indented"
                            [class.agpr-profileSection-content--inner]="!lastSub"
                        >
                            <dt class="agpr-profileSection-attribute">{{ topSubject.name }}</dt>
                            <div>
                                @for (childSubject of topSubject.children; track childSubject.id; let last = $last) {
                                    <dd>
                                        {{ childSubject.name }} {{ !last ? ', ' : '' }}
                                    </dd>
                                }
                            </div>
                        </dl>
                    }
                </agpr-panel>
            }

            @if (outletEntity?.mediaTypes && outletEntity?.mediaTypes.length > 0  && fullEntity.entityType === entityTypes.OUTLET) {
                <agpr-panel
                    [id]="id + '_contactDetails.entityProfile.mediaType'"
                    header="Discover.entityProfile.mediaType"
                    [headingLevel]="5"
                    [marginTop]="15"

                >
                    <div class="agpr-profileSection-content">
                        @for (mediaType of outletEntity?.mediaTypes; track $index; let last = $last) {
                            {{ mediaType.displayString | localize }} {{ !last ? ', ' : '' }}
                        }
                    </div>
                </agpr-panel>
            }

            @if (outletEntity?.productType && fullEntity.entityType === entityTypes.OUTLET) {
                <agpr-panel
                    [id]="id + '_contactDetails.entityProfile.productType'"
                    header="Discover.entityProfile.productType"
                    [headingLevel]="5"
                    [marginTop]="15"
                >
                    <div class="agpr-profileSection-content">
                        {{ outletEntity.productType.displayString }}
                    </div>
                </agpr-panel>
            }

            @if (outletEntity?.marketSector && fullEntity.entityType === entityTypes.OUTLET) {
                <agpr-panel
                    [id]="id + '_contactDetails.entityProfile.marketSector'"
                    header="Discover.entityProfile.marketSector"
                    [headingLevel]="5"
                    [marginTop]="15"
                >
                    {{ outletEntity.marketSector.displayString }}
                </agpr-panel>
            }

            @if (roleFamilies?.length > 0 && fullEntity.entityType === entityTypes.CONTACT) {
                <agpr-panel
                    [id]="id + '_contactDetails.entityProfile.jobRoles'"
                    header="Discover.entityProfile.jobRoles"
                    [headingLevel]="5"
                    [marginTop]="15"
                >
                    @for (roleFamily of roleFamilies; track $index; let lastRole = $last) {
                        <dl
                            class="agpr-profileSection-content indented"
                            [class.agpr-profileSection-content--inner]="!lastRole"
                        >
                            <dt class="agpr-profileSection-attribute">{{ roleFamily.family | titlecase }}</dt>
                            <div>
                                @for (role of roleFamily.roles; track $index; let last = $last) {
                                    <dd> {{ role.displayString }} {{ !last ? ', ' : '' }} </dd>
                                }
                            </div>
                        </dl>
                    }
                </agpr-panel>
            }

            @if (outletEntity?.coverageFocus) {
                <agpr-panel
                    [id]="id + '_contactDetails.entityProfile.targetAudienceRegion'"
                    header="Discover.entityProfile.targetAudienceRegion"
                    [headingLevel]="5"
                    [marginTop]="15"
                >
                    <dl class="agpr-profileSection-content indented targetAudienceRegion">
                        <dt class="agpr-profileSection-attribute">
                            {{ outletEntity.coverageFocus?.displayString }}
                        </dt>
                        @for (targetAudienceRegion of outletEntity.targetAudienceRegions; track $index) {
                            <dd>
                                @if (outletEntity.targetAudienceRegions.length === 1) {
                                    <span>
                                        {{ targetAudienceRegion.keyString }}
                                    </span>
                                } @else {
                                    <div>
                                        {{ targetAudienceRegion.keyString }}
                                    </div>
                                }
                            </dd>
                        }
                    </dl>
                </agpr-panel>
            }

            <!-- TODO: The shape of this data will change with back-end changes. Currently only US Media Markets are available -->

            @if (outletEntity?.mediaMarkets && outletEntity?.mediaMarkets.length > 0) {
                <agpr-panel
                    [id]="id + '_contactDetails.entityProfile.mediaMarkets'"
                    header="Discover.entityProfile.mediaMarkets"
                    [headingLevel]="5"
                    [marginTop]="15"
                >
                    <dl class="agpr-profileSection-content indented">
                        <dt class="agpr-profileSection-attribute">
                            {{ outletEntity.mediaMarkets[0].getTypeDisplayString() }}
                        </dt>
                        <div>
                            @for (mediaMarket of outletEntity.mediaMarkets; track $index) {
                                <dd> {{ mediaMarket.displayString }} </dd>
                            }
                        </div>
                    </dl>
                </agpr-panel>
            }

            @if (outletEntity?.circulations && outletEntity?.circulations.length > 0) {
                <agpr-panel
                    [id]="id + '_contactDetails.entityProfile.audienceReach'"
                    header="Discover.entityProfile.audienceReach"
                    [headingLevel]="5"
                    [marginTop]="15"

                >
                    <div class="agpr-profileSection-content">
                        @for (circulation of outletEntity.circulations; track $index; let last = $last) {
                            <div
                                [class.agpr-profileSection-content--inner]="!last"
                                class="agpr-profileSection-content-circulation"
                            >
                                <agpr-meta-data
                                    [id]="id"
                                    [type]="attributeTypes.audienceReach"
                                    [icon]="circulationTypeToIcon.get(circulation.circulationType.enumValue)"
                                    [value]="circulation.value"
                                    [isSimilarWeb]="circulation.isSimilarWeb"
                                    [tooltip]="circulation.circulationType.displayString"
                                ></agpr-meta-data>
                            </div>
                        }
                    </div>
                </agpr-panel>
            }

            @if (outletEntity?.domainAuthority) {
                <agpr-panel
                    [id]="id + '_contactDetails.entityProfile.domainAuthority'"
                    header="Discover.entityProfile.domainAuthority"
                    [headingLevel]="5"
                    [marginTop]="15"
                >
                    <div class="agpr-profileSection-content">
                        <agpr-meta-data
                            [id]="id"
                            [type]="attributeTypes.domainAuthority"
                            [icon]="'fa-solid fa-gauge-simple-high'"
                            [value]="outletEntity.domainAuthority"
                            [tooltip]="'Discover.entityProfile.domainAuthority'"
                            [infoTooltip]="'Mention.details.domainAuthorityTooltip'"
                        ></agpr-meta-data>
                    </div>
                </agpr-panel>
            }

            @if (outletEntity?.targetAudiences && outletEntity?.targetAudiences.length > 0) {
                <agpr-panel
                    [id]="id + '_contactDetails.entityProfile.targetAudiences'"
                    header="Discover.entityProfile.targetAudiences"
                    [headingLevel]="5"
                    [marginTop]="15"
                >
                    <div class="agpr-profileSection-content">
                        @for (targetAudience of outletEntity.targetAudiences; track $index; let last = $last) {
                            <div> {{ targetAudience.displayString }} </div>
                        }
                    </div>
                </agpr-panel>
            }

            @if (languages?.length > 0) {
                <agpr-panel
                    [id]="id + '_contactDetails.entityProfile.language'"
                    header="Discover.entityProfile.language"
                    [headingLevel]="5"
                    [marginTop]="15"
                >
                    <div class="agpr-profileSection-content">
                        @for (language of languages; track $index; let isLast = $last) {
                            {{ language.name | localize }}{{ isLast? '' : ',' }}
                        }
                    </div>
                </agpr-panel>
            }

            @if ((handleTypes?.length > 0 || targetingAccessLevel === targetingAccessLevels.NO_ACCESS || isGeoRestricted) && !isRefMediaAccount) {
                <agpr-panel
                    [id]="id + '_contactDetails.entityProfile.contactInformation'"
                    [header]="_entityType === entityTypes.CONTACT ? 'Discover.entityProfile.contactInformation' : 'Discover.entityProfile.outletInformation'"
                    [headingLevel]="5"
                    [marginTop]="15"
                >
                    @if (targetingAccessLevel === targetingAccessLevels.NO_ACCESS || isGeoRestricted) {
                        <div class="agpr-entityProfile-upsellCard">
                            <div class="agpr-entityProfile-demoContactInfo">
                                <span
                                    role="img"
                                    class="agpr-entityProfile-upsellCard-lockIcon fa-regular fa-lock fa-duotone"
                                    aria-labelledby="upsellCard_info"
                                ></span>
                                <span
                                    role="img"
                                    class="agpr-entityProfile-demoContactInfo-icon"
                                    [ngClass]="handleIconMap[handleTypeEnum.EMAIL]"
                                    [agprTooltip]="'Common.handleTypes.' + handleTypeEnum.EMAIL"
                                ></span>
                                <span class="agpr-entityProfile-demoContactInfo-filler">contact&#64;company.ca</span>
                                <span
                                    role="img"
                                    class="agpr-entityProfile-demoContactInfo-icon"
                                    [ngClass]="handleIconMap[handleTypeEnum.PHONE]"
                                    [agprTooltip]="'Common.handleTypes.' + handleTypeEnum.PHONE"
                                ></span>
                                <span class="agpr-entityProfile-demoContactInfo-filler">+1 234.567.8901</span>
                                <span
                                    role="img"
                                    class="agpr-entityProfile-demoContactInfo-icon"
                                    [ngClass]="handleIconMap[handleTypeEnum.TWITTER]"
                                    [agprTooltip]="'Common.handleTypes.' + handleTypeEnum.TWITTER"
                                ></span>
                                <span class="agpr-entityProfile-demoContactInfo-filler">contactx</span>
                                <span
                                    role="img"
                                    class="agpr-entityProfile-demoContactInfo-icon"
                                    [ngClass]="handleIconMap[handleTypeEnum.INSTAGRAM]"
                                    [agprTooltip]="'Common.handleTypes.' + handleTypeEnum.INSTAGRAM"
                                ></span>
                                <span class="agpr-entityProfile-demoContactInfo-filler">contactinstagram</span>
                                <span
                                    role="img"
                                    class="agpr-entityProfile-demoContactInfo-icon"
                                    [ngClass]="handleIconMap[handleTypeEnum.FACEBOOK]"
                                    [agprTooltip]="'Common.handleTypes.' + handleTypeEnum.FACEBOOK"
                                ></span>
                                <span class="agpr-entityProfile-demoContactInfo-filler">contactfacebook</span>
                                <span
                                    role="img"
                                    class="agpr-entityProfile-demoContactInfo-icon"
                                    [ngClass]="handleIconMap[handleTypeEnum.LINKEDIN]"
                                    [agprTooltip]="'Common.handleTypes.' + handleTypeEnum.LINKEDIN"
                                ></span>
                                <span class="agpr-entityProfile-demoContactInfo-filler">contactlinkedin</span>
                                <span
                                    role="img"
                                    class="agpr-entityProfile-demoContactInfo-icon"
                                    [ngClass]="handleIconMap[handleTypeEnum.YOUTUBE]"
                                    [agprTooltip]="'Common.handleTypes.' + handleTypeEnum.YOUTUBE"
                                ></span>
                                <span class="agpr-entityProfile-demoContactInfo-filler">contactyoutube</span>
                                <span
                                    role="img"
                                    class="agpr-entityProfile-demoContactInfo-icon"
                                    [ngClass]="handleIconMap[handleTypeEnum.TIKTOK]"
                                    [agprTooltip]="'Common.handleTypes.' + handleTypeEnum.TIKTOK"
                                ></span>
                                <span class="agpr-entityProfile-demoContactInfo-filler">contacttiktok</span>
                                <span
                                    role="img"
                                    class="agpr-entityProfile-demoContactInfo-icon"
                                    [ngClass]="handleIconMap[handleTypeEnum.BLUESKY]"
                                    [agprTooltip]="'Common.handleTypes.' + handleTypeEnum.BLUESKY"
                                ></span>
                                <span class="agpr-entityProfile-demoContactInfo-filler">contactbluesky</span>
                            </div>
                            <div
                                id="upsellCard_info"
                                class="agpr-entityProfile-upsellCard-info"
                            >
                                @if (targetingAccessLevel === targetingAccessLevels.NO_ACCESS) {
                                    <span> {{ 'Discover.entityProfile.targetingUpsell.contactMessage' | localize }} </span>
                                } @else if (isGeoRestricted) {
                                    <span> {{ 'Discover.entityProfile.targetingUpsell.contactMessage.geoRestriction' | localize }} </span>
                                }
                            </div>
                            <agpr-button
                                id="recentCoverage.contactButton"
                                label="Discover.entityProfile.targetingUpsell.contactButton"
                                [style]="buttonTypes.primary"
                                (click)="navigateToSubscription()"
                            ></agpr-button>
                        </div>
                    } @else {
                        <div class="agpr-handles">
                            @for (handleType of handleTypes; track $index) {
                                <div class="agpr-handles-type">
                                    <span
                                        role="img"
                                        [class]="handleIconMap[handleType.type]"
                                        [agprTooltip]="handleType.tooltip"
                                    ></span>
                                </div>
                                <div>
                                    @for (handle of handleType.handles; track $index) {
                                        <div class="agpr-handles-handle">
                                            @if (handle.link) {
                                                <a
                                                    [href]="handle.link"
                                                    target="_blank"
                                                    rel="noopener"
                                                    class="agpr-handles-link"
                                                >
                                                    {{ handle.value }}
                                                </a>
                                            } @else {
                                                {{ handle.value }}
                                            }

                                            @if (handle.isPrivateData) {
                                                <span
                                                    role="img"
                                                    class="agpr-handles-privateBadge fa-regular fa-duotone fa-shield-keyhole"
                                                    agprTooltip="Discover.addPrivateDataDialog.privateData"
                                                ></span>
                                            }

                                            @if (handle.primary && handleType.handles.length > 1) {
                                                <span
                                                    role="img"
                                                    class="agpr-handles-privateBadge fa-regular fa-duotone fa-award"
                                                    agprTooltip="Discover.entityProfile.handle.primary"
                                                ></span>
                                            }

                                            @if (handle.preferred) {
                                                <span
                                                    role="img"
                                                    class="agpr-handles-privateBadge fa-solid fa-star"
                                                    agprTooltip="Discover.entityProfile.handle.preferred"
                                                ></span>
                                            }

                                            <span class="agpr-handles-contextMenu">
                                                <!-- You are only able to set the primary as "preferred" as a way of clearing a
                                                    previous preference. Private contacts cannot have a preferred email since
                                                    users are allowed to modify the primary email instead (in the editor).
                                                    privateContactMetadata is only available on contacts, since private outlets arn't possible
                                                -->
                                                @if (
                                                    !$any(fullEntity)?.privateContactMetadata &&
                                                    !handle.preferred &&
                                                    handle.handleType === handleTypeEnum.EMAIL &&
                                                    ((handle.primary && hasPreferredEmail) || !handle.primary)
                                                ) {
                                                    <agpr-button
                                                        [style]="buttonTypes.icon"
                                                        [tooltip]="'Discover.entityProfile.handle.preferred.set'"
                                                        (click)="setPreferred(handle)"
                                                        class="agpr-handles-contextMenu-setPreferred"
                                                        icon="fa-regular fa-star"
                                                    ></agpr-button>
                                                }
                                            </span>
                                        </div>
                                    }
                                </div>
                            }
                        </div>
                    }
                </agpr-panel>
            }

            @if (
                ((hasContactAddresses || (contactPrivateAddresses.length > 0)) &&
                (targetingAccessLevel !== targetingAccessLevels.NO_ACCESS) &&
                !isGeoRestricted)
                && !isRefMediaAccount
            ) {
                <agpr-panel
                    [id]="id + '_contactDetails.entityProfile.address'"
                    header="Discover.entityProfile.address"
                    [headingLevel]="5"
                    [marginTop]="15"
                >
                    <div class="agpr-addresses-wrapper">
                        @if (hasContactAddresses) {
                            <div class="agpr-addresses">
                                <div>{{ contactEntity?.addressLine1 }}</div>
                                <div>{{ contactEntity?.addressLine2 }}</div>
                                <!-- using keyString instead of displayString since it doesn't have (City) suffixes -->
                                <div>{{ contactEntity?.geography?.keyString }}</div>
                                <div>{{ contactEntity?.postalCode }}</div>
                            </div>
                        }

                        @for (address of contactPrivateAddresses; track $index) {
                            <div class="agpr-addresses">
                                @if (address.addressLine1) {
                                    <div class="agpr-addresses-field">
                                        {{ address.addressLine1 }}
                                    </div>
                                }

                                @if (address.addressLine2) {
                                    <div class="agpr-addresses-field">
                                        {{ address.addressLine2 }}
                                    </div>
                                }

                                @if (address.geography?.keyString) {
                                    <div class="agpr-addresses-field">
                                        {{ address.geography.keyString }}
                                    </div>
                                }

                                @if (address.postalCode) {
                                    <div class="agpr-addresses-field">
                                        {{ address.postalCode }}
                                    </div>
                                }

                                <span
                                    role="img"
                                    class="agpr-addresses-privateBadge fa-regular fa-duotone fa-shield-keyhole"
                                    agprTooltip="Discover.addPrivateDataDialog.privateData"
                                    tooltipPosition="top"
                                ></span>
                            </div>
                        }
                    </div>
                </agpr-panel>
            }

            @if (((hasSystemAddresses || (outletPrivateAddresses.length > 0)) && (targetingAccessLevel !== targetingAccessLevels.NO_ACCESS) && !isGeoRestricted) && !isRefMediaAccount) {
                <agpr-panel
                    [id]="id + '_contactDetails.entityProfile.outletAddress'"
                    header="Discover.entityProfile.outletAddress"
                    [headingLevel]="5"
                    [marginTop]="15"
                >
                    <div class="agpr-addresses-wrapper">
                        @if (hasSystemAddresses) {
                            <div class="agpr-addresses">
                                <div>{{ outletEntity?.addressLine1 }}</div>
                                <div>{{ outletEntity?.addressLine2 }}</div>
                                <div>{{ outletEntity?.geography?.keyString }}</div>
                                <div>{{ outletEntity?.postalCode }}</div>
                            </div>
                        }

                        @for (address of outletPrivateAddresses; track $index) {
                            <div class="agpr-addresses">
                                @if (address.addressLine1) {
                                    <div class="agpr-addresses-field">
                                        {{ address.addressLine1 }}
                                    </div>
                                }

                                @if (address.addressLine2) {
                                    <div class="agpr-addresses-field">
                                        {{ address.addressLine2 }}
                                    </div>
                                }

                                @if (address.geography?.keyString) {
                                    <div class="agpr-addresses-field">
                                        {{ address.geography.keyString }}
                                    </div>
                                }

                                @if (address.postalCode) {
                                    <div class="agpr-addresses-field">
                                        {{ address.postalCode }}
                                    </div>
                                }

                                <span
                                    role="img"
                                    class="agpr-addresses-privateBadge fa-regular fa-duotone fa-shield-keyhole"
                                    agprTooltip="Discover.addPrivateDataDialog.privateData"
                                ></span>
                            </div>
                        }
                    </div>
                </agpr-panel>
            }
        }
    </div>

    @if (showOverlay && !isRefMediaAccount) {
        <div
            class="agpr-showMoreOverlay"
            [@movingUpsell]="annimationState"
            (@movingUpsell.done)="showOverlay = !showMore"
        >
            <div class="agpr-showMoreOverlay-bio"></div>
            <div class="agpr-showMoreOverlay-wrapper">
                <div class="agpr-showMoreOverlay-linkButton">
                    <agpr-button
                        [style]="buttonTypes.link"
                        (click)="showMoreAnimation()"
                    >
                        <span class="agpr-showMoreOverlay-linkButton-label">
                            {{ "Discover.entityProfile.showMore" | localize }}
                        </span>
                        <span
                            class="fa-solid fa-angle-down"
                            aria-hidden="true"
                        ></span>
                    </agpr-button>
                </div>
                <div class="agpr-entityProfile-upsellCard agpr-showMoreOverlay-upsellCard">
                    <span class="agpr-showMoreOverlay-upsellCard-lockIcon fa-regular fa-lock fa-duotone"></span>
                    <div class="agpr-showMoreOverlay-upsellCard-info">
                        @if (targetingAccessLevel === targetingAccessLevels.NO_ACCESS) {
                            <span>
                                {{ 'Discover.entityProfile.targetingUpsell.contactMessage' | localize }}
                            </span>
                        }

                        @if (isGeoRestricted && (targetingAccessLevel !== targetingAccessLevels.NO_ACCESS)) {
                            <span>
                                {{ 'Discover.entityProfile.targetingUpsell.contactMessage.geoRestriction' | localize }}
                            </span>
                        }
                    </div>

                    <agpr-button
                        id="recentCoverage_contactButton_collapsed"
                        label="Discover.entityProfile.targetingUpsell.contactButton"
                        [style]="buttonTypes.primary"
                        (click)="navigateToSubscription()"
                    ></agpr-button>
                </div>
            </div>
        </div>
    }
}
